<template>
  <div class="main main__container">
    <oie-layout-grid css-classes="grid--two">
      <div class="sign-in">
        <h3 class="sign-in__header">
          {{ t('resetPasswordHeader') }}
        </h3>

        <p class="sign-in__description">
          {{ t('resetPasswordDescription') }}
        </p>

        <div class="sign-in-box">
          <validation-observer
            ref="observer"
            v-slot="{ invalid }"
            tag="form"
            @submit.prevent="validateForm()">
            <validation-provider
              v-slot="{errors}"
              vid="pw"
              rules="required|passwordPolicy"
              slim>
              <oie-base-input-v2
                id="register-password"
                v-model="password"
                autocomplete="new-password"
                type="password"
                required
                :label="tStatic('password')"
                :placeholder="tStatic('passwordPlaceholder')"
                :description="tStatic('passwordPolicy')"
                :errors="errors">
              </oie-base-input-v2>
            </validation-provider>

            <validation-provider
              v-slot="{errors}"
              rules="required|password:pw"
              slim>
              <oie-base-input-v2
                id="register-repeat-password"
                v-model="reEnteredPassword"
                type="password"
                required
                autocomplete="new-password"
                :label="tStatic('passwordMatch')"
                :placeholder="tStatic('passwordMatchPlaceholer')"
                :errors="errors">
              </oie-base-input-v2>
            </validation-provider>

            <validation-provider
              v-slot="{errors}"
              rules="checked"
              slim>
              <oie-base-radio-checkbox
                v-model="acceptTerms"
                type="checkbox"
                :label="t('approveTerms')"
                :description="t('approveTermsLabel')"
                class="input-column__checkbox"
                :errors="errors">
              </oie-base-radio-checkbox>
            </validation-provider>

            <div class="sign-in-box__actions">
              <oie-base-action
                v-element-loader="{ endpoint: 'auth/resetPassword' }"
                class="sign-in-box__button"
                type="submit">
                {{ t('resetButton') }}
              </oie-base-action>
            </div>

            <div>
              {{ informationText }}
            </div>
          </validation-observer>
        </div>
      </div>

      <div class="sign-in sign-in--register">
      </div>
    </oie-layout-grid>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  props: {
    userId: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    informationText: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    password: null,
    reEnteredPassword: null,
    acceptTerms: false
  }),
  methods: {
    async validateForm() {
      const isValid = await this.$refs.observer.validate()

      if (!isValid) {
        // ABORT

      } else {
        this.resetPassword()
      }
    },
    resetPassword() {
      httpService.post('auth/resetPassword', { password: this.password, userId: this.userId, token: this.token }).then((response) => {
        window.location = response.data.url
      })
    }
  }
}
</script>
